import { createAction } from '@reduxjs/toolkit';
import { StationsServed, RequestError } from 'types';

export const fetch = createAction('stations-served/fetch', (name: string, date: string) => ({
  payload: undefined,
  meta: { name, date },
}));

export const success = createAction('stations-served/success', (data?: StationsServed[]) => ({
  payload: data,
}));

export const error = createAction('stations-served/error', (requestError: RequestError) => ({
  payload: requestError,
}));

export default {
  fetch,
  success,
  error,
};
